import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	constructor(private _http: HttpClient) {
	}

	getStatesAndProvinces() {
		return this._http.get<any>('./app/config/states-and-provinces.json');
	}
}
